import React from 'react';

const useIsVisible = function ({ observerOptions, }) {
    const [isVisible, setIsVisible] = React.useState(false);
    const { root, rootMargin, threshold } = observerOptions;
    const observer = React.useMemo(() => {
        const observerCallback = function (entries) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
                else {
                    setIsVisible(false);
                }
            });
        };
        if (typeof window !== 'undefined' && window.IntersectionObserver) {
            return new IntersectionObserver(observerCallback, {
                root,
                rootMargin,
                threshold,
            });
        }
    }, [root, rootMargin, threshold]);
    const element = React.useRef(null);
    const unobserve = React.useCallback(() => {
        if (element.current) {
            observer?.unobserve(element.current);
        }
    }, [observer]);
    const setElement = React.useCallback((el) => {
        if (!observer) {
            setIsVisible(undefined);
        }
        else {
            unobserve();
            element.current = el;
            observer.observe(element.current);
        }
    }, [observer, unobserve]);
    /**
     * Destroy observer:
     */
    React.useEffect(() => {
        return () => {
            observer?.disconnect();
        };
    }, [observer]);
    return [isVisible, setElement, unobserve];
};

export { useIsVisible };
//# sourceMappingURL=index.js.map
